import styled from 'styled-components'
import { Drawer as DrawerAnt } from 'antd'
import { themeFontFamily } from 'LibNeo/theme'

export const StyledDrawer = styled(DrawerAnt)`
	.ant-drawer-wrapper-body {
		position: relative;
		overflow: hidden;
		width: 100%;
	}
	.ant-drawer-header {
		z-index: 2;
	}
	.ant-drawer-body {
		height: calc(100% - 65px);
		overflow: auto;
		.ppneo-page-block:last-child {
			padding: 0;
		}
	}
	.ant-drawer-body {
		height: calc(100% - 70px);
	}
	.ant-drawer-title {
		font-family: ${themeFontFamily('SBSansText')};
		font-size: 24px;
		font-style: normal;
		font-weight: 600;
		line-height: 32px;
		letter-spacing: -0.01em;
		text-align: left;
	}
	.ant-drawer-wrapper-body {
		&::-webkit-scrollbar {
			width: 0;
		}
	}
`
